import * as React from 'react';
import classnames from 'clsx';
import type { IDirection } from '../MemberLoginDialog.types';
import style from './style/style.scss';
import type { SiteMembersTranslations } from './utils';
import { MemberLoginDialogTranslationKeys as keys } from './utils';

export type MandatorySSODialogProps = {
  id: string;
  directionByLanguage: IDirection;
  headlineId: string;
  children: React.ReactNode;
} & SiteMembersTranslations;

export const MandatorySSODialog: React.FC<MandatorySSODialogProps> = ({
  id,
  directionByLanguage,
  headlineId,
  translations,
  children,
}) => {
  return (
    <div
      id={id}
      className={classnames(style.memberLoginContent, {
        [style.rtl]: directionByLanguage === 'rtl',
      })}
    >
      <h2 id={headlineId} className={style.ssoTitle}>
        {translations[keys.ssoTitle] ?? 'Log in with your organization account'}
      </h2>
      <h3 className={style.ssoSubtitle}>
        {translations[keys.ssoSubtitle] ??
          'Your organization requires login with SSO. Continue to enter this site.'}
      </h3>
      <div className={classnames(style.contentWrapper, style.wrapper)}>
        {children}
      </div>
    </div>
  );
};
